import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { UserFieldErrorMessages } from "@constants/Errors";
import {
  handleNumericalCheck,
  handleNumericalFieldChange,
  phoneNumberChange,
} from "@services/ErrorHandling";
import { handlePostCodeChange } from "@services/ErrorHandling";
import { TenantFieldErrorMessages } from "@constants/Errors";
import { USER } from "@types/user";

type UserCompanyInfoCardProps = {
  userData: USER;
  updateUserData: (field: string, value: any) => void;
  errors: any;
  updateError: (field: string, value: any) => void;
};

export const UserCompanyInfoCard = ({
  userData,
  updateUserData,
  errors,
  updateError,
}: UserCompanyInfoCardProps) => {
  return (
    <div>
      <TextInputField
        label="支社名"
        value={userData?.company_name}
        placeholder="株式支社サンプル"
        onChange={(e) =>
          handleNumericalCheck(
            "company_name",
            e.target.value,
            updateUserData,
            updateError,
          )
        }
      />
      {errors.company_name && (
        <p className="text-red-500">{UserFieldErrorMessages.nameError}</p>
      )}

      <div className="divider mt-5 mb-6"></div>

      <TextInputField
        label="支社電話番号 （ハイフンなし）"
        placeholder="（例）0312345678"
        value={userData?.company_tel}
        onChange={(e) =>
          phoneNumberChange(
            "company_tel",
            e.target.value,
            updateUserData,
            updateError,
          )
        }
      />
      {errors.company_tel && (
        <p className="text-red-500">
          {UserFieldErrorMessages.telephoneNumberError}
        </p>
      )}
      {/* <p className="mt-2 text-mayo-light-gray">
        {messages.user.personal_tel_or_company_tel_required}
      </p> */}

      <div className="divider mt-5 mb-6"></div>

      <TextInputField
        label="支社FAX番号 （ハイフンなし）"
        value={userData?.company_fax}
        placeholder="（例）0312345678"
        onChange={(e) =>
          phoneNumberChange(
            "company_fax",
            e.target.value,
            updateUserData,
            updateError,
          )
        }
      />
      {errors.company_fax && (
        <p className="text-red-500">{UserFieldErrorMessages.faxNumberError}</p>
      )}

      <div className="divider mt-5 mb-6"></div>

      <TextInputField
        label={"支社郵便番号 （ハイフンなし）"}
        value={userData?.company_postal_code}
        placeholder="1234567"
        onChange={(e) =>
          handlePostCodeChange(
            "company_postal_code",
            e.target.value,
            updateUserData,
            updateError,
          )
        }
      />
      {errors.company_postal_code && (
        <p className="text-red-500">{TenantFieldErrorMessages.postcodeError}</p>
      )}
      <div className="divider mt-5 mb-6"></div>

      <TextInputField
        label="支社住所"
        className={"form-text-field-border"}
        value={userData?.company_address}
        placeholder="東京都中央区サンプル町1-2-3"
        onChange={(e) => updateUserData("company_address", e.target.value)}
      />
      {errors.company_address && (
        <p className="text-red-500">{TenantFieldErrorMessages.postcodeError}</p>
      )}
    </div>
  );
};
